/* Step 11c · item 1 (Mars find 40) — EN + AR of the three neutral AI error kinds (backend/ai_error_text.py TEXT, same words).
   Used by lib/aiErrorText.js (aiErr.<kind>) and, through toErrMsg, by the error codes a request answers with (errors.<CODE>).
   No provider name in any text here (CLAUDE.md §3). */
export default {
  en: {
    aiErr: {
      allowance: "AI allowance used up — ask your firm administrator.",
      unavailable: "AI service unavailable — try again later.",
      rejected: "AI request rejected.",
    },
    errors: {
      AI_ALLOWANCE_USED_UP: "AI allowance used up — ask your firm administrator.",
      AI_SERVICE_UNAVAILABLE: "AI service unavailable — try again later.",
      AI_REQUEST_REJECTED: "AI request rejected.",
    },
  },
  ar: {
    aiErr: {
      allowance: "نفدت حصة الذكاء الاصطناعي — اطلب من مسؤول مكتبكم.",
      unavailable: "خدمة الذكاء الاصطناعي غير متاحة — حاول مرة أخرى لاحقًا.",
      rejected: "رُفض طلب الذكاء الاصطناعي.",
    },
    errors: {
      AI_ALLOWANCE_USED_UP: "نفدت حصة الذكاء الاصطناعي — اطلب من مسؤول مكتبكم.",
      AI_SERVICE_UNAVAILABLE: "خدمة الذكاء الاصطناعي غير متاحة — حاول مرة أخرى لاحقًا.",
      AI_REQUEST_REJECTED: "رُفض طلب الذكاء الاصطناعي.",
    },
  },
};
